import React, { useState } from 'react';
import MediaQuery from 'react-responsive';
import Clipboard from 'clipboard';
import {
  PAYPAL_THEME,
  Button,
  CheckmarkIcon,
  BodyText,
  Container,
  Row,
} from '@paypalcorp/pp-react';
import styles from './CopyButton.less';

const CopyButton = ({ clickCopy = () => {}, text, copyText }) => {
  new Clipboard('#clipBoardTrigger');
  const [isCopied, setIsCopied] = useState(false);

  const renderButton = () => (
    <Button
      theme='v2'
      size='sm'
      id='clipBoardTrigger'
      className={`${styles['clip-btn-style']}`}
      data-clipboard-target='#clipBoardBodyText'
      style={
        isCopied
          ? {
              border: 'none',
              backgroundColor: PAYPAL_THEME.sysColorAccent3Main,
              color: PAYPAL_THEME.sysColorBackgroundSurface,
            }
          : {
              backgroundColor: PAYPAL_THEME.sysColorBackgroundSurface,
              borderColor: PAYPAL_THEME.sysColorPrimaryMain,
              color: PAYPAL_THEME.sysColorPrimaryMain,
            }
      }
      onClick={(e) => {
        if (!isCopied) {
          clickCopy(e);
        }
        setIsCopied(!isCopied);
      }}
    >
      {!isCopied ? copyText : <CheckmarkIcon size='sm' />}
    </Button>
  );

  const renderText = () => (
    <BodyText className={`${styles['text-to-copy']}`} id={'clipBoardBodyText'}>
      {text}{' '}
    </BodyText>
  );

  return (
    <>
      <MediaQuery minWidth={752}>
        <div
          style={{
            display: 'flex',
          }}
        >
          <div
            className={`${styles['copy-container']}`}
            style={{
              backgroundColor: PAYPAL_THEME.sysColorBackgroundMain,
            }}
          >
            {renderText()}
            {renderButton()}
          </div>
        </div>
      </MediaQuery>
      <MediaQuery maxWidth={751}>
        <Container>
          <Row style={{ paddingBottom: '1rem' }}>{renderText()}</Row>
          <Row>{renderButton()}</Row>
        </Container>
      </MediaQuery>
    </>
  );
};

export default CopyButton;
